import styled from 'styled-components';
import { pxToRem } from '../../../assets/styles/helper';
import themeColors from '../../../assets/styles/themeColors';

// Decorative background pattern
const BackgroundPattern = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: radial-gradient(
      circle at 20% 80%,
      rgba(255, 255, 255, 0.1) 0%,
      transparent 50%
    ),
    radial-gradient(
      circle at 80% 20%,
      rgba(255, 255, 255, 0.1) 0%,
      transparent 50%
    );
  z-index: 1;
`;

const Flex = styled.div`
  display: flex;
  flex-direction: column;
  align-items: left;
`;

const Error = styled.div`
  font-size: ${pxToRem(12)};
  line-height: 1;
  margin-bottom: ${pxToRem(-1)};
  dispay: flex;
  color: ${themeColors.colorRed};
`;

export default { BackgroundPattern, Flex, Error };
